import { S as StepComponent$1, d as defineCustomElement$1 } from './step-component2.js';
const StepComponent = StepComponent$1;
const defineCustomElement = defineCustomElement$1;
export { StepComponent, defineCustomElement };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm1hcHBpbmdzIjoiIiwiaWdub3JlTGlzdCI6W119